<template>
  <div class="d-flex align-center">
    <v-row dense>
      <v-col cols="auto">
        <v-btn
          icon
          @click="navigateDate(-1)"
        >
          <v-icon small>
            fa fa-arrow-left
          </v-icon>
        </v-btn>
      </v-col>
      <v-col cols="auto">
        <v-menu
          v-model="datePickerVisible"
          :close-on-content-click="false"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :value="formattedDate"
              :label="label"
              dense
              solo
              hide-details
              readonly
              :loading="loading"
              style="width: 250px"
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="localDate"
            no-title
            :first-day-of-week="1"
            :max="$dayjs().format('YYYY-MM-DD')"
            @input="datePickerVisible = false"
          />
        </v-menu>
      </v-col>
      <v-col cols="auto">
        <v-btn
          icon
          :disabled="isToday"
          @click="navigateDate(1)"
        >
          <v-icon small>
            fa fa-arrow-right
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'DateSelector',
  props: {
    value: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: 'Date'
    },
    format: {
      type: String,
      default: 'dddd, ll'
    },
    disableFuture: {
      type: Boolean,
      default: true
    },
    disablePast: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      datePickerVisible: false,
      localDate: this.value ? this.value.format('YYYY-MM-DD') : null
    }
  },
  computed: {
    formattedDate() {
      return this.localDate ? dayjs(this.localDate).format(this.format) : null
    },
    isToday() {
      if (!this.localDate) return false
      return this.disableFuture && dayjs().isSame(dayjs(this.localDate), 'date')
    }
  },
  watch: {
    value(newValue) {
      this.localDate = newValue ? newValue.format('YYYY-MM-DD') : null
    },
    localDate(newValue) {
      if (newValue) {
        this.$emit('input', dayjs(newValue))
      }
    }
  },
  methods: {
    dayjs,
    navigateDate(direction) {
      if (!this.localDate) return

      const newDate = dayjs(this.localDate).add(direction, 'day')

      if (this.disableFuture && newDate.isAfter(dayjs(), 'date')) {
        return
      }

      if (this.disablePast && newDate.isBefore(dayjs(), 'date')) {
        return
      }

      this.localDate = newDate.format('YYYY-MM-DD')
    }
  }
}
</script>
